import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { DeploymentCard } from "@/components/Deployments";
import { Activity, Zap } from "lucide-react";
import { Link } from "react-router-dom";

export default function Deployments() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();

  const load = async () => {
    try {
      const { data } = await api.get("/deployments");
      setRows(data);
    } catch { toast.error("Failed to load"); }
    finally { setLoading(false); }
  };
  useEffect(() => {
    load();
    const t = setInterval(load, 20000);
    return () => clearInterval(t);
  }, []);

  const patch = async (dep, status) => {
    try {
      await api.patch(`/deployments/${dep.deployment_id}`, { status });
      toast.success(`Deployment ${status}`);
      load();
    } catch { toast.error("Update failed"); }
  };
  const del = async (dep) => {
    if (!window.confirm("Delete this deployment? Trade history is preserved elsewhere.")) return;
    await api.delete(`/deployments/${dep.deployment_id}`);
    toast.success("Deleted");
    load();
  };

  return (
    <div className="min-h-screen"><Navbar/>
      <main className="max-w-[1400px] mx-auto px-6 py-10">
        <div className="flex items-end justify-between mb-8">
          <div>
            <div className="chip mb-3"><Activity size={12}/> LIVE DEPLOYMENTS</div>
            <h1 className="font-display text-4xl text-white tracking-tight">Deployments</h1>
            <p className="text-sm text-[var(--text-secondary)] mt-1 max-w-2xl">
              Strategies you've deployed to a live broker. The runner ticks every 60 seconds — entry signals fire real orders, closed trades are logged here.
            </p>
          </div>
        </div>

        {loading ? (
          <p className="text-xs font-mono uppercase tracking-widest text-[var(--text-secondary)]">Loading…</p>
        ) : rows.length === 0 ? (
          <div className="card-sharp p-12 text-center" data-testid="deployments-empty">
            <Zap className="mx-auto text-[var(--text-muted)]" size={40}/>
            <h3 className="font-display text-2xl text-white mt-4">No deployments yet</h3>
            <p className="text-sm text-[var(--text-secondary)] mt-2 max-w-md mx-auto">
              Open any saved strategy and click "Deploy to broker" to start running it live.
            </p>
            <Link to="/dashboard" className="btn-primary inline-flex items-center gap-2 mt-6">Go to strategies</Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="deployments-grid">
            {rows.map(dep => (
              <DeploymentCard key={dep.deployment_id} dep={dep}
                onOpen={(d) => nav(`/deployments/${d.deployment_id}`)}
                onPatch={patch} onDelete={del}/>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
